import { createContext, type PropsWithChildren, useContext, useMemo } from 'react';

import useBoolean from '@front/common/src/hooks/use-boolean';

type AppContextValue = {
  isLeavingApp: boolean;
  setIsLeavingApp: () => void;
};

export const AppContext = createContext<AppContextValue>({ isLeavingApp: false, setIsLeavingApp: () => {} });

export const AppContextProvider = ({ onLeavingApp, children }: PropsWithChildren<{ onLeavingApp?: () => void }>) => {
  const { value: isLeavingApp, setTrue: setIsLeavingAppTrue } = useBoolean(false);
  const value = useMemo(
    () => ({
      isLeavingApp,
      setIsLeavingApp: () => {
        setIsLeavingAppTrue();
        if (onLeavingApp) onLeavingApp();
      },
    }),
    [isLeavingApp, onLeavingApp, setIsLeavingAppTrue],
  );
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useIsLeavingApp = () => {
  const { isLeavingApp, setIsLeavingApp } = useContext(AppContext);
  return { isLeavingApp, setIsLeavingApp };
};
